import React from 'react'
import styled from 'styled-components'
import { SubmenuItem, PermissionAction } from './types'

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-bottom: 6px;
  border: 1px solid #e2e8f0;

  &:hover {
    background-color: #f8fafc;
  }
`

const SubmenuName = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #334155;
`

const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  user-select: none;
`

const CustomCheckbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #0284c7;
  cursor: pointer;
`

interface SubmenuRowProps {
  submenu: SubmenuItem
  onChange: (submenuId: string, updatedPermissions: SubmenuItem['permissions']) => void
}

export const SubmenuRow: React.FC<SubmenuRowProps> = ({ submenu, onChange }) => {
  const handleCheckboxClick = (action: PermissionAction) => {
    const current = submenu.permissions[action]
    const nextVal = !current

    const newPermissions = { ...submenu.permissions, [action]: nextVal }

    if (action === 'ver' && !nextVal) {
      newPermissions.criar = false
      newPermissions.editar = false
      newPermissions.deletar = false
    } else if ((action === 'criar' || action === 'editar' || action === 'deletar') && nextVal) {
      newPermissions.ver = true
    }

    onChange(submenu.id, newPermissions)
  }

  return (
    <RowContainer>
      <SubmenuName>{submenu.name}</SubmenuName>
      <CheckboxGroup>
        {(['ver', 'criar', 'editar', 'deletar'] as PermissionAction[]).map((action) => (
          <CheckboxLabel key={action}>
            <CustomCheckbox
              type="checkbox"
              checked={submenu.permissions[action]}
              onChange={() => handleCheckboxClick(action)}
            />
            {action.toUpperCase()}
          </CheckboxLabel>
        ))}
      </CheckboxGroup>
    </RowContainer>
  )
}
